module.exports = __webpack_public_path__ + "img/优品证券.57203b7d.png";